import useTableRestQuery from "@/directory/hooks/useTableRestQuery";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";

const DEFAULT_SORT_BY = [{ id: "last_name", desc: false }];

const useTeacherStudentGetList = (
  teacherId,
  pageSize,
  defaultSortBy = DEFAULT_SORT_BY,
) => {
  return useTableRestQuery(
    `${MONOLITH_ORIGIN}/api/v3/teacher/${teacherId}/student/`,
    pageSize,
    defaultSortBy,
  );
};

export default useTeacherStudentGetList;
